import styled from 'styled-components';

import { ICON_REFRESH } from 'assets/icons';
import CommonImage from 'components/common/CommonImage';

const RefreshButtonStyle = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  width: fit-content;
  height: 36px;

  padding: 0px 12px;
  margin: 0px auto;

  border-radius: 8px;
  border: 0;

  font-weight: 600;
  font-size: 14px;
  line-height: 36px;
  color: rgba(70, 71, 76, 1);

  background-color: rgba(244, 244, 245, 1);

  >img {
    width: 14px,
    height: 14px,

    pointer-events: 'none',
  } 
`;

interface Props {
  handleRefreshData: () => void;
  toastMessage?: string;
}

function RefreshButton({ handleRefreshData, toastMessage }: Props) {
  const refreshHandler = () => {
    handleRefreshData();
    window.showToast(
      toastMessage ?? '새로고침이 완료되었습니다.',
      'success',
      3000,
    );
  };

  return (
    <RefreshButtonStyle onClick={refreshHandler}>
      <CommonImage src={ICON_REFRESH} onClick={() => {}} />
      새로고침
    </RefreshButtonStyle>
  );
}

export default RefreshButton;
